export const SET_LOG_IN_STATUS = 'auth.SET_LOG_IN_STATUS';
export const FORGOT_PASSWORD = 'auth.FORGOT_PASSWORD';
export const SET_LOADING_STATUS = 'auth.SET_LOADING_STATUS';
